import React from 'react'
import classes from './WhatIsPays.module.css'
import vouchersGroup from '../../assets/img/vouchers-group.svg'

export default function WhatIsPays() {
  return (
    <div className={classes.whatIsPaysContainer}>
      <div className='container px-3'>
        <div className={`${classes.whatIsPays} font-pays row`}>
          <div className='col-12 col-lg-6 d-flex justify-content-center align-items-center'>
            <div>
              <h2>Was ist Pays?</h2>
              <p className={`font-pays`}>
                Mit pays hast Du seit 2018 die Möglichkeit rund um die Uhr, mit
                und optional ohne Vorkasse*, sofort digitale Gutscheincodes zu
                erhalten und diese in den jeweiligen Online-Shops sofort
                einzusetzen.
              </p>
              <span className='small font-pays'>* Bonität vorausgesetzt</span>
            </div>
          </div>
          <div className='col-12 col-lg-6 d-flex justify-content-center align-items-center'>
            <img src={vouchersGroup} alt='Vouchers' className='w-100 mt-5 mt-lg-0' />
          </div>
        </div>
      </div>
    </div>
  )
}
